import { apiService } from './api.service'

export interface ProcessedMail {
  id: number
  rule: number // MailRule.id
  folder: string
  uid: number
  subject: string
  received: string
  processed: string
  status: string
  error?: string | null
}

export interface ProcessedMailListResponse {
  count: number
  next: string | null
  previous: string | null
  results: ProcessedMail[]
}

class ProcessedMailService {
  private baseUrl = 'processed_mail/'

  async getProcessedMails(ruleId: number, page: number = 1, pageSize: number = 25): Promise<ProcessedMailListResponse> {
    const response = await apiService.get(`${this.baseUrl}?rule=${ruleId}&page=${page}&page_size=${pageSize}`)
    return response.data
  }

  async bulkDelete(mailIds: number[]): Promise<void> {
    await apiService.post(`${this.baseUrl}bulk_delete/`, {
      mail_ids: mailIds,
    })
  }

  async delete(id: number): Promise<void> {
    await apiService.delete(`${this.baseUrl}${id}/`)
  }

  async listFiltered(
    page: number = 1,
    pageSize: number = 25,
    ordering: string = '-processed',
    search?: string,
    rule?: number
  ): Promise<ProcessedMailListResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      ordering,
    })

    if (search) {
      params.append('search', search)
    }

    if (rule) {
      params.append('rule', rule.toString())
    }

    const response = await apiService.get(`${this.baseUrl}?${params.toString()}`)
    return response.data
  }
}

export const processedMailService = new ProcessedMailService()
